import { Directive, Input, HostListener } from "@angular/core";
import { HelpService } from "./help.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { HelpComponent } from "./help.component";

@Directive({
	selector: "[nstarHelp]",
})
export class HelpDirective {
	@Input() nstarHelp: { module: string; page: string };
	@HostListener("click") onClick() {
		this.helpService.showHelp(this.nstarHelp);
		this.ngbModal.open(HelpComponent, {
			centered: true,
			scrollable: true,
			size: "lg",
		});
	}

	constructor(private helpService: HelpService, private ngbModal: NgbModal) {}
}
